<template>
<footer class="site-footer text-white">
  <div class="container py-4 d-flex flex-column flex-md-row justify-content-between align-items-center">
    <div class="mb-3 mb-md-0">
      © {{ new Date().getFullYear() }} Blackstar Merchant Services. All rights reserved.
    </div>
    <div>
      <a href="/legal/privacy-policy" class="text-white me-3">Privacy Policy</a>
      <a href="/legal/terms" class="text-white">Terms of Service</a>
    </div>
  </div>
</footer>

</template>

<script>
export default {
  name: 'PageFooter',
  props: {
  }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.site-footer {
  background-color: var(--primary); /* or use #343a40 for dark grey */
  font-size: 0.9rem;
}
.site-footer a {
  text-decoration: none;
}
.site-footer a:hover {
  text-decoration: underline;
}

</style>
